import {Component, OnInit} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {Router} from "@angular/router";
import {AppService} from "@services/app.service";
import {NgxSpinnerService} from "ngx-spinner";
import {Enquiry} from "@/models/enquiry/Enquiry";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-enquiry',
  templateUrl: './enquiry.component.html',
  styleUrl: './enquiry.component.scss'
})
export class EnquiryComponent implements OnInit {
  searchText;
  enquiries: Enquiry[] = [];
  enquiryStatus: string = "";

  constructor(
    private router: Router,
    private appService: AppService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) {
  }

  ngOnInit() {
    this.getAllEnquiries();
  }


  //Get all enquiries form customers
  getAllEnquiries() {
    this.spinner.show();
    this.appService.getAllEnquiryList()
      .subscribe({
        next: (response: Enquiry[]) => {
          this.spinner.hide();
          this.enquiries = response;
          this.enquiries.sort((a, b) => b.enquiryId - a.enquiryId);
          console.log('Enquiries loaded:', this.enquiries);
        },
        error: (error) => {
          this.spinner.hide();
          console.error('Error fetching enquiries:', error);
          this.toastr.error(error.error.message);
        },
        complete: () => {
          this.spinner.hide();
          console.log('Enquiry fetch completed');
        }
      });
  }

  updateEnquiryStatus(enquiry: Enquiry,index: number, status: string) {
    this.enquiryStatus = status;
    this.spinner.hide();
    const updateStatus = {
      enquiryId: enquiry.enquiryId,
      status: this.enquiryStatus
    }
    console.log(updateStatus)
    this.appService.updateEnquiryStatusByEnquiryId(updateStatus)
      .subscribe({
        next: (response: Enquiry) => {
          this.spinner.hide();
          this.getAllEnquiries();
          this.enquiries.sort((a, b) => b.enquiryId - a.enquiryId);
          this.toastr.success(`Enquiry status updated successfully`);
          console.log('Enquiries loaded:', this.enquiries);
        },
        error: (error) => {
          this.spinner.hide();
          console.error('Error fetching enquiries:', error);
          this.toastr.error(error.error.message);
        },
        complete: () => {
          console.log('Enquiry fetch completed');
        }
      });
  }

  invoiceDetails(enquiry: Enquiry) {
    localStorage.setItem('lfCustomerDetail', JSON.stringify(enquiry));
    this.router.navigate(['/main/invoice'])
  }

}
